import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin-left: 50px;
`

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 10px;
`

export const InfoContainer = styled.div`
  width: 580px;
  display: flex;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0px;
`

export const BigInfoContainer = styled(InfoContainer)`
  width: 680px;
`

export const FilterContainer = styled.div`
  display: flex;
  min-width: 500px;
  flex-direction: row;
  justify-content: center;
  align-self: center;
  align-items: center;
  margin-top: 15px;
  gap: 10px;
`

export const TabStickyContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  padding: 0px 40px;
  margin-bottom: 10px;
  position: sticky;
  top: 0px;
  z-index: 3;
`

export const ReportsContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  justify-items: stretch;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 10px;
  gap: 12px;

  @media (min-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 979px) {
    grid-template-columns: 1fr;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin: 20px 0px 10px;
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 7px;
`

export const Column = styled(Container)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px;
  margin-left: 0px;
`

export const LinkText = styled(LookButton).attrs(buttonLook({ variant: 'link' }))``

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin: 7px 0px 0px;
  align-self: center;
`

export const SubTitle = styled(InfoText)`
  font-weight: 500;
`

export const MoneyText = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`
